var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome1Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92122 0.977043C10.0204 0.902648 10.1393 0.859437 10.263 0.852529C10.4101 0.844318 10.5553 0.888628 10.6731 0.977043L20.0429 8.00838C20.6988 8.5006 19.9469 9.5015 19.291 9.00937L10.2947 2.26002L1.32049 8.99228C0.625263 9.51391 -0.121706 8.51297 0.573453 7.99129L9.92122 0.977043Z",
    fill: "#161E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 4.33768C10.1388 4.33867 10.0203 4.38762 9.92122 4.4622L2.11514 10.3375C1.95861 10.4553 1.86613 10.6396 1.86613 10.8356V20.2278C1.86613 20.5735 2.14795 20.8516 2.49354 20.8516H7.81315C8.16018 20.8516 8.44184 20.5713 8.44057 20.2241L8.42226 15.2338H12.1721V20.2278C12.1721 20.5716 12.451 20.8516 12.7946 20.8516H18.0996C18.4452 20.8516 18.727 20.5735 18.727 20.2278V10.8356C18.727 10.6397 18.6345 10.4553 18.478 10.3375L10.6731 4.46219C10.5724 4.38635 10.4507 4.33669 10.2947 4.33768Z",
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1Svg);
export default __webpack_public_path__ + "static/media/home1svg.99b568afb31b3e583f04e3bf6dab1ad0.svg";
export { ForwardRef as ReactComponent };